export default {
  inserted(el, binding) {
    const defaultOptions = {
      exitDelay: 0,
      interval: 100,
      sensitivity: 7,
    }
    let config = {}

    let currX
    let currY
    let prevX
    let prevY
    let pollTimer
    let exitTimer

    // override default options with user config
    const extend = (defaults, userArgs) => {
      return {
        ...defaults,
        ...userArgs,
      }
    }

    // update mouse position
    const mouseTrack = (ev) => {
      currX = ev.pageX
      currY = ev.pageY
    }

    // check if mouse movement has slowed enough to trigger active state
    const mouseCompare = (targetElem, ev) => {
      const distX = prevX - currX
      const distY = prevY - currY
      const distance = Math.sqrt(distX * distX + distY * distY)

      if (distance < config.sensitivity) {
        /**
         * if we re-entered an element,
         * cancel delayed exit and clear any active elements immediately
         */
        clearTimeout(exitTimer)

        if (targetElem.isActive) {
          config.onExit(targetElem)
          targetElem.isActive = false
        }

        // trigger hover
        config.onEnter(targetElem)
        targetElem.isActive = true
      } else {
        // update previous coordinates and try again later
        prevX = currX
        prevY = currY
        pollTimer = setTimeout(() => {
          mouseCompare(targetElem, ev)
        }, config.interval)
      }
    }

    // Named handlers so `unbind` can remove the exact same references. Previously
    // these were inline arrows with no teardown, so the listeners (and the
    // `config.onEnter/onExit` closures over the component) were never released —
    // every detached element stayed alive via Blink and dragged its whole Vue
    // component subtree into a leak on each slide switch.
    const onMouseEnter = (ev) => {
      // set initial entry position
      prevX = ev.pageX
      prevY = ev.pageY
      // if this element is already active, cancel exit
      if (el.isActive) {
        clearTimeout(exitTimer)
        return
      }

      // while mouse is over this element, check distance every 100ms
      pollTimer = setTimeout(() => {
        mouseCompare(el, ev)
      }, config.interval)
    }

    const onMouseLeave = () => {
      clearTimeout(pollTimer)
      if (!el.isActive) return

      exitTimer = setTimeout(() => {
        config.onExit(el)
        el.isActive = false
      }, config.exitDelay)
    }

    const init = (elem, userConfig) => {
      if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
        // throw 'onEnter and onExit callbacks must be provided'
        return
      }
      config = extend(defaultOptions, userConfig)

      elem.isActive = false
      // keeps track of mouse position
      elem.addEventListener('mousemove', mouseTrack)
      elem.addEventListener('mouseenter', onMouseEnter)
      elem.addEventListener('mouseleave', onMouseLeave)

      // Persist teardown on the element so the `unbind` hook (a separate Vue
      // directive call) can remove the listeners and clear pending timers.
      elem._hoverIntentTeardown = () => {
        elem.removeEventListener('mousemove', mouseTrack)
        elem.removeEventListener('mouseenter', onMouseEnter)
        elem.removeEventListener('mouseleave', onMouseLeave)
        clearTimeout(pollTimer)
        clearTimeout(exitTimer)
      }
    }

    init(el, binding.value)
  },

  unbind(el) {
    if (el._hoverIntentTeardown) {
      el._hoverIntentTeardown()
      delete el._hoverIntentTeardown
    }
  },
}
